module.exports = __webpack_public_path__ + "img/rascrut-12.09775428.jpg";